import { boardTypeSchema } from '@/backend/features/board-files/shared';
import { useTranslation } from '@/ui/hooks';
import { WidgetFormConfig } from '@juvare/common-form-ui/WidgetForm';
import { WidgetFormRichTextEditorConfig } from '@juvare/common-form-ui/WidgetFormRichTextEditor';
import { WidgetFormSelectConfig } from '@juvare/common-form-ui/WidgetFormSelect';
import { WidgetFormTextConfig } from '@juvare/common-form-ui/WidgetFormText';
import React from 'react';

export function useBoardFormConfig(side: 'generic' | 'industry'): WidgetFormConfig {
    const { t } = useTranslation();
    return React.useMemo<WidgetFormConfig>(
        () => ({
            type: 'form',
            children: [
                ...(side === 'generic'
                    ? [
                          {
                              type: 'form.text',
                              key: 'board',
                              label: t('board'),
                              validate: { required: true },
                          } satisfies WidgetFormTextConfig,
                          {
                              type: 'form.select',
                              key: 'type',
                              label: t('type'),
                              values: boardTypeSchema.options.map((type) => ({
                                  value: type,
                                  label: t(`boardTypeEnum.${type}`),
                              })),
                              validate: { required: true },
                          } satisfies WidgetFormSelectConfig,
                      ]
                    : [
                          {
                              type: 'form.text',
                              key: 'industry',
                              label: t('industry'),
                              validate: { required: true },
                          } satisfies WidgetFormTextConfig,
                          {
                              type: 'form.text',
                              key: 'board',
                              label: t('board'),
                              validate: { required: true },
                          } satisfies WidgetFormTextConfig,
                      ]),
                {
                    type: 'form.richTextEditor',
                    key: 'description',
                    editorInit: {
                        toolbar: 'undo redo | bold italic list link image',
                    },
                } satisfies WidgetFormRichTextEditorConfig,
            ],
        }),
        [side, t],
    );
}
